webpackJsonp([263791100135453],{

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Wojtek-2023-edited.79f3ef78.jpg";

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Wojtek.0a7505ff.jpg";

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/justjoinit.fa100822.jpg";

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/whoishiring.f0c3cffa.jpg";

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  @media (min-width: 650px) {\n    margin: 0 2.5em;\n  }\n\n  @media (min-width: 850px) {\n    margin: 0 5em;\n  }\n\n  h2 {\n    font-size: 42px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #ccc;\n  }\n\n  h3 {\n    font-size: 36px;\n  }\n'], ['\n  @media (min-width: 650px) {\n    margin: 0 2.5em;\n  }\n\n  @media (min-width: 850px) {\n    margin: 0 5em;\n  }\n\n  h2 {\n    font-size: 42px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #ccc;\n  }\n\n  h3 {\n    font-size: 36px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 0 0 3em;\n'], ['\n  margin: 0 0 3em;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n'], ['\n  display: flex;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 0 -50vw;\n  width: 100vw;\n  position: relative;\n  left: 50%;\n  right: 50%;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n\n  @media (max-width: 600px) {\n    height: 0;\n    padding-top: 56.25%;\n\n    img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n'], ['\n  margin: 0 -50vw;\n  width: 100vw;\n  position: relative;\n  left: 50%;\n  right: 50%;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n\n  @media (max-width: 600px) {\n    height: 0;\n    padding-top: 56.25%;\n\n    img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: 16px;\n\n  @media (min-width: 800px) {\n    margin: 0 auto 2em;\n\n    p {\n      margin-right: 20%;\n    }\n  }\n\n  .intro {\n    font-size: 20px;\n    margin-right: 0;\n  }\n\n  aside {\n    ol,\n    li {\n      margin: 0;\n      padding: 0;\n      list-style-type: none;\n    }\n\n    li {\n      padding: 10px 0;\n    }\n  }\n'], ['\n  font-size: 16px;\n\n  @media (min-width: 800px) {\n    margin: 0 auto 2em;\n\n    p {\n      margin-right: 20%;\n    }\n  }\n\n  .intro {\n    font-size: 20px;\n    margin-right: 0;\n  }\n\n  aside {\n    ol,\n    li {\n      margin: 0;\n      padding: 0;\n      list-style-type: none;\n    }\n\n    li {\n      padding: 10px 0;\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  @media (min-width: 600px) {\n    display: flex;\n\n    > div {\n      width: 50%;\n      padding-left: 20px;\n\n      &:first-of-type {\n        padding-left: 0;\n        padding-right: 20px;\n      }\n    }\n  }\n'], ['\n  @media (min-width: 600px) {\n    display: flex;\n\n    > div {\n      width: 50%;\n      padding-left: 20px;\n\n      &:first-of-type {\n        padding-left: 0;\n        padding-right: 20px;\n      }\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  ul {\n    margin: 0;\n  }\n\n  li {\n    list-style: none;\n    margin: 0 0 2em;\n    padding-left: 20px;\n  }\n\n  [data-xteam]:after {\n    content: \' *\';\n  }\n\n  h4 {\n    margin: 0 0 0.5em -20px;\n    font-size: 18px;\n    font-weight: 400;\n\n    > a {\n      border-bottom: 1px solid #ccc;\n      padding-bottom: 1px;\n\n      // &:after {\n      //   content: \' \u2192\';\n      // }\n\n      &:hover {\n        border-color: #000;\n      }\n    }\n  }\n\n  h4 + strong {\n    display: block;\n    font-weight: 600;\n  }\n\n  h4 + strong + p {\n    color: rgba(0, 0, 0, 0.6);\n  }\n'], ['\n  ul {\n    margin: 0;\n  }\n\n  li {\n    list-style: none;\n    margin: 0 0 2em;\n    padding-left: 20px;\n  }\n\n  [data-xteam]:after {\n    content: \' *\';\n  }\n\n  h4 {\n    margin: 0 0 0.5em -20px;\n    font-size: 18px;\n    font-weight: 400;\n\n    > a {\n      border-bottom: 1px solid #ccc;\n      padding-bottom: 1px;\n\n      // &:after {\n      //   content: \' \u2192\';\n      // }\n\n      &:hover {\n        border-color: #000;\n      }\n    }\n  }\n\n  h4 + strong {\n    display: block;\n    font-weight: 600;\n  }\n\n  h4 + strong + p {\n    color: rgba(0, 0, 0, 0.6);\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n\n  a {\n    max-width: 100%;\n    position: relative;\n\n    &:after {\n      position: absolute;\n      content: \' \';\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(255, 255, 255, 0.2);\n      z-index: 3;\n      transition: all 0.05s;\n    }\n\n    &:hover:after {\n      background: none;\n    }\n\n    > img {\n      display: block;\n      margin: 0;\n    }\n\n    > span {\n      display: block;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      background: rgba(255, 255, 255, 0.8);\n      z-index: 5;\n      padding: 3px 5px;\n    }\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n\n  a {\n    max-width: 100%;\n    position: relative;\n\n    &:after {\n      position: absolute;\n      content: \' \';\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(255, 255, 255, 0.2);\n      z-index: 3;\n      transition: all 0.05s;\n    }\n\n    &:hover:after {\n      background: none;\n    }\n\n    > img {\n      display: block;\n      margin: 0;\n    }\n\n    > span {\n      display: block;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      background: rgba(255, 255, 255, 0.8);\n      z-index: 5;\n      padding: 3px 5px;\n    }\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Wojtek = __webpack_require__(690);
	
	var _Wojtek2 = _interopRequireDefault(_Wojtek);
	
	var _Wojtek2023Edited = __webpack_require__(170);
	
	var _Wojtek2023Edited2 = _interopRequireDefault(_Wojtek2023Edited);
	
	var _whoishiring = __webpack_require__(693);
	
	var _whoishiring2 = _interopRequireDefault(_whoishiring);
	
	var _justjoinit = __webpack_require__(692);
	
	var _justjoinit2 = _interopRequireDefault(_justjoinit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var AboutPage = _styledComponents2.default.div(_templateObject);
	
	var Section = _styledComponents2.default.section(_templateObject2);
	
	var Container = _styledComponents2.default.div(_templateObject3);
	
	var Pic = _styledComponents2.default.div(_templateObject4);
	
	var Bio = _styledComponents2.default.article(_templateObject5);
	
	var TwoCol = _styledComponents2.default.div(_templateObject6);
	
	var Experience = _styledComponents2.default.div(_templateObject7);
	
	var Interviews = _styledComponents2.default.section(_templateObject8);
	
	var technical = [
	// {
	//   company: <a href="https://x-team.com">X-Team</a>,
	//   title: 'Lead Front-End Engineer',
	//   date: 'Jul 2006 – now'
	// },
	{
	  company: _react2.default.createElement(
	    'a',
	    { href: 'https://eulerlabs.com', target: '_blank', rel: 'noopener noreferrer' },
	    'Euler Labs'
	  ),
	  title: 'Tech Lead UI/UX',
	  date: 'Feb 2022 - Feb 2026'
	}, {
	  company: _react2.default.createElement(
	    'a',
	    { href: 'https://kaplan.com', target: '_blank', rel: 'noopener noreferrer' },
	    'Kaplan, Inc.'
	  ),
	  title: 'Lead Front-End Engineer',
	  date: 'Jan 2015 – Mar 2021',
	  xteam: true
	}, {
	  company: _react2.default.createElement(
	    'a',
	    { href: 'https://fox.com', target: '_blank', rel: 'noopener noreferrer' },
	    'Fox Broadcasting Company'
	  ),
	  title: 'Senior Front-end Engineer',
	  date: 'Jul 2010 – Dec 2014',
	  xteam: true
	}, {
	  company: _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://xfive.co', target: '_blank', rel: 'noopener noreferrer' },
	      'Xfive.co'
	    ),
	    ' ',
	    '/',
	    ' ',
	    _react2.default.createElement(
	      'a',
	      { href: 'https://x-team.com', target: '_blank', rel: 'noopener noreferrer' },
	      'X-Team'
	    )
	  ),
	  title: 'Senior Front-end Engineer',
	  date: 'Jul 2006 – Jul 2010'
	}];
	
	var leadership = [{
	  company: _react2.default.createElement(
	    'a',
	    { href: 'http://worldisyouroffice.com/' },
	    'World is your office'
	  ),
	  title: 'Co-founder, partner',
	  date: 'Jun 2018 – Jan 2019'
	}, {
	  company: _react2.default.createElement(
	    'a',
	    { href: 'https://fox.com', target: '_blank', rel: 'noopener noreferrer' },
	    'Fox Broadcasting Company'
	  ),
	  title: 'Team Lead',
	  date: 'Sep 2013 - Dec 2014',
	  xteam: true
	}, {
	  company: _react2.default.createElement(
	    'a',
	    { href: 'https://xfive.co', rel: 'noopener noreferrer' },
	    'Xfive.co'
	  ),
	  title: 'Branch Manager',
	  date: 'Nov 2010 – Dec 2014'
	}];
	
	var About = function (_React$Component) {
	  _inherits(About, _React$Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  About.prototype.render = function render() {
	    var listExperience = function listExperience(title) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      return _react2.default.createElement(
	        Experience,
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          data.map(function (position, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'h4',
	                { 'data-xteam': position.xteam },
	                position.company
	              ),
	              _react2.default.createElement(
	                'strong',
	                null,
	                position.title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                position.date
	              )
	            );
	          })
	        )
	      );
	    };
	
	    return _react2.default.createElement(
	      AboutPage,
	      null,
	      _react2.default.createElement(
	        Section,
	        null,
	        _react2.default.createElement(
	          Pic,
	          null,
	          _react2.default.createElement('img', { src: _Wojtek2023Edited2.default, alt: 'Wojtek' })
	        )
	      ),
	      _react2.default.createElement(
	        Section,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Bio,
	            null,
	            _react2.default.createElement(
	              'p',
	              { className: 'intro' },
	              'I\u2019m Wojtek Zaj\u0105c',
	              _react2.default.createElement(
	                'sup',
	                { className: 'footnotelink', id: 'fnhref:pronunciation' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#fn:pronunciation' },
	                  '1'
	                )
	              ),
	              ', a software engineer originally from Krak\xF3w, Poland. Since 2010, I\'ve been traveling extensively\u2014transitioning to a fully nomadic lifestyle in 2014. Over the past years, I\'ve lived in six different countries, embracing the concept of personal sovereignty through location independence.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'intro' },
	              'My professional work is mostly related to front-end development, which I got into in the early 2000s.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Within Front-End, I specialize in Web Accessibility, and I\'ve given',
	              ' ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/speaking/' },
	                'several workshops and presentations'
	              ),
	              ' on the topic. In 2005, published the first online course of',
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://en.wikipedia.org/wiki/Polish_Sign_Language' },
	                'Polish Sign Language'
	              ),
	              '. I\'ve worked with major universities in the U.S., UK, and Australia, as well as governmental institutions, ensuring their websites comply with accessibility regulations.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Throughout my career, I\'ve collaborated with notable clients such as Twitter, Kaplan, Inc., and Riot Games on various front-end development projects. I also coordinated the development of high-traffic websites for American Idol and The X-Factor USA.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'I\'ve gained experience in diverse team structures, from fully distributed groups to traditional single-site teams. For four years, I established and led a local branch of an international software house, growing it to 18 team members.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Currently, my interests revolve around technical leadership and fostering company culture that leverages remote working and asynchronous communication.'
	            ),
	            _react2.default.createElement(
	              'aside',
	              { className: 'footnotes' },
	              _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  { id: 'fn:pronunciation' },
	                  '1. My first name is pronounced "Voitek". ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#fnhref:pronunciation' },
	                    '\u21A9'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Section,
	        null,
	        _react2.default.createElement(
	          TwoCol,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Featured clients'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Twitter, Kaplan Inc., FOX Broadcasting Company, Riot Games, Rogers Media, Threadless'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Recommended stack'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Next.js, Redux, TypeScript, Styled Components, CSS\xA0Modules, Web Accessibility, Storybook'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Section,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Experience'
	        ),
	        _react2.default.createElement(
	          TwoCol,
	          null,
	          listExperience('Technical', technical),
	          listExperience('Leadership', leadership)
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Through X-Team'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'For a more detailed work history, please see',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.linkedin.com/in/wojciechzajac/' },
	            'Linkedin'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement(
	        Section,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Interviews'
	        ),
	        _react2.default.createElement(
	          Interviews,
	          null,
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://x-team.com/blog/interview-wojtek-zajac',
	                  lang: 'en',
	                  target: '_blank',
	                  rel: 'noopener noreferrer'
	                },
	                '[EN] On what it means to be an existential migrant'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://blog.whoishiring.io/wojtek-zajac-on-his-early-career-remote-work-and-accessibility/',
	                  target: '_blank',
	                  rel: 'noopener noreferrer',
	                  lang: 'en'
	                },
	                '[EN] On early career, remote work and accessibility'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://geek.justjoin.it/wieku-16-stworzyl-front-end-twittera-dzis-pracuje-klientami-calego-swiata/',
	                  target: '_blank',
	                  rel: 'noopener noreferrer',
	                  lang: 'pl'
	                },
	                '[PL] W wieku 16 lat stworzy\u0142 front-end Twittera. Dzi\u015B pracuje z klientami z ca\u0142ego \u015Bwiata'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react2.default.Component);
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-15200bcf86337f43d4a5.js